import React from 'react';

import { Button } from 'components/Button';

import CustomModal from 'components/CustomModal';

interface DraftContinuationModalProps {
  open: boolean;
  onClose: () => void;
  onContinueDraft: () => void;
  onStartNew: () => void;
}

/**
 * Modal component that asks the user whether they want to continue with an existing draft
 * or start a new submission when a draft exists in IndexedDB
 */
const DraftContinuationModal: React.FC<DraftContinuationModalProps> = ({
  open,
  onClose,
  onContinueDraft,
  onStartNew,
}): React.ReactElement => (
  <CustomModal
    openModal={open}
    onClose={onClose}
    modalTitle="Continue with existing draft?"
    modalDescription={`We found an existing draft for this form. 
      Would you like to continue where you left off or start fresh?`}
    cancelButton={
      <Button id="start-new-button" onClick={onStartNew} variant="outlined" size="large" fullWidth>
        Start New
      </Button>
    }
    submitButton={
      <Button id="continue-draft-button" onClick={onContinueDraft} variant="contained" size="large" fullWidth>
        Continue Draft
      </Button>
    }
  />
);

export default DraftContinuationModal;
